<template>
	<div class="pb-2">
		<div v-if="!reload">
			<select class="form-control form-control-sm form-control-faded" :multiple="this.schema.multi" :id="'choice_'+random" v-model="value">
				<option v-for="option in schema.values" v-bind:value="option[schema.options.value]" :selected="(value == option[schema.options.value])? 'selected' : ''">
					{{ option[schema.options.name] }}
				</option>
			</select>
		</div>
	</div>
</template>

<script>
    import { abstractField } from "vue-form-generator";
    import Choices from 'choices.js'
    export default {
        name: 'vfg-field-choices',
        mixins: [ abstractField ],
        data () {
            return {
                t: this.$root.t,
                result: null,
                selected: [],
                random: 0,
	            reload: false
            }
        },
        watch: {
			value (o, n) {

			}
        },
	    updated () {

	    },
        mounted () {

            this.randomId()
        },
        methods: {

            randomId () {
                var min = 100;
                var max = 1000;
                var random = Math.floor(Math.random() * (max - min + 1)) + min;
                this.random = random;
                this.choices(random)
            },
            clear () {
                if(!this.q) {
                    this.result = null;
                    this.value = [];
                }
            },
            setValue (val, tit) {
                console.log(val);
                if(val) {
                    if (this.schema.multi) {
                        if (this.schema.onlyId) {
                            this.value.push(val.id);
                        }else  {
                            this.value.push(val);
                        }

                    }else {
                        this.value = val.id;
                    }

                    this.q = tit;
                    this.result = null;
                }else {
                    this.result = null;
                    if(!this.value){
                        this.value = [];
                    }
                }

            },
	        choices (random) {

                setTimeout(() => {
                    var element = window.document.getElementById('choice_'+random);

	                var example = new Choices(element, {
	                    removeItemButton: true,
	                    silent: false,
	                });
                }, 300);
	        }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.choices__button {
		float: right !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/form/fieldChoices.vue